import { Modal } from "./Modal";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = "确认",
  cancelLabel = "返回",
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal open={open} title={title} eyebrow="请确认操作" description={description} busy={busy} onClose={onCancel}>
      <div className="confirm-dialog__actions">
        <button type="button" className="button button--quiet" data-autofocus onClick={onCancel} disabled={busy}>{cancelLabel}</button>
        <button type="button" className={`button ${danger ? "button--danger" : "button--primary"}`} onClick={onConfirm} disabled={busy}>
          {busy ? <span className="button-spinner" /> : null}{busy ? "处理中" : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
